'use client';

import { QueryKeys } from '@/constants/query-keys';
import { transactionsApiService } from '@/services/(frontend)/profile/transactions-api.service';
import { PurchaseHistory } from '@/types/purchase-history';
import { useQuery } from '@tanstack/react-query';
import { useDynamicStaleTime } from '../shared/dynamic-stale-time';
import { useIsAuthReady } from './is-auth-ready';

export const useTransactions = (enabled = true): ReturnType<typeof useQuery<PurchaseHistory[]>> => {
  const updateQueryStaleTime = useDynamicStaleTime();
  const { isAuthenticated } = useIsAuthReady();

  return useQuery<PurchaseHistory[]>({
    enabled: enabled && isAuthenticated,
    queryFn: async () => {
      const response = await transactionsApiService.getTransactions();

      if (response.headers) {
        updateQueryStaleTime(QueryKeys.user.transactions, response.headers);
      }

      return response.data;
    },
    queryKey: QueryKeys.user.transactions,
  });
};
